// Preview ID format defined by prothea: [a-z0-9-]{1,63}.
// Anything else is treated as a non-preview hostname.
const PREVIEW_ID_PATTERN = /^[a-z0-9-]{1,63}$/

/**
 * Extracts the preview ID from the current hostname.
 * Example: pr-123.ebalance-dev.dev.shared.enechain.com → "pr-123"
 * Returns null in non-preview environments.
 */
export function getPreviewId(): string | null {
  const base = import.meta.env.VITE_FRONTEND_BASE_HOST
  const current = window.location.hostname
  if (!base || current === base || !current.endsWith(`.${base}`)) return null
  const id = current.slice(0, -(base.length + 1))
  return PREVIEW_ID_PATTERN.test(id) ? id : null
}

/**
 * Prepends the preview ID as a subdomain to the given baseUrl.
 * Returns baseUrl as-is if not in a preview environment.
 */
export function buildPreviewUrl(baseUrl: string): string {
  const previewId = getPreviewId()
  if (previewId === null) return baseUrl
  const url = new URL(baseUrl)
  url.hostname = `${previewId}.${url.hostname}`
  return url.toString()
}
